import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { WebOfficeStoreContext } from './contexts/WebOfficeStoreContext'
import { createWebOfficeStore } from './store/createStore'

export const WebOfficeStoreProvider = ({ children }: PropsWithChildren) => {
  const store = useCreation(() => createWebOfficeStore(), [])

  return <WebOfficeStoreContext value={store}>{children}</WebOfficeStoreContext>
}
